import { IReinvestmentInstructionViewModel } from "../../models/termDeposits/reinvestment-instruction";
import { BaseHttpService } from "./base.http.service";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AppConfig } from "../../app.config";
import { IEnvironmentConfig } from "../../models/environmentConfig";
import { Observable, of } from "rxjs";

@Injectable()
export class ReinvestmentService extends BaseHttpService {

    constructor(private http: HttpClient, private appConfig: AppConfig) {
        super();
    }
    
    get envSettings(): IEnvironmentConfig {
        return this.appConfig.getEnvironmentConfig();
    }


    public getReinvestmentInstructions(portfolioIds: number[]) : Observable<IReinvestmentInstructionViewModel[]>{
        const url = new URL(`${this.envSettings.webApiUrl}portfolios/reinvestment`);
        
        if(!!!portfolioIds || portfolioIds.length === 0){
            return of([]);
        }

        // Add portfolioIds to the query string.
        portfolioIds.forEach(portfolioId => {
            url.searchParams.append('portfolioIds', portfolioId.toString());
        });
        
        return this.http.get<IReinvestmentInstructionViewModel[]>(url.toString(), {
            observe: "body",
            responseType: "json",
            headers: this.getHttpHeaders()
        });
    }

    public editReinvestmentInstruction(instructionId: number, portfolioId: number, reinvestmentInstruction: IReinvestmentInstructionViewModel) {
        const url = new URL(`${this.envSettings.webApiUrl}portfolio/${portfolioId}/reinvestment/${instructionId}`);
        return this.http.post(url.toString(), reinvestmentInstruction);
    }
}